<div class="row m-0" style="overflow: hidden;">
    <div class="col">
        <div class="row d-flex align-items-center" style="height: 100vh">
            <div class="col"></div>
            <div class="col-lg-8">
                <img src="../../assets/img/outlive-chat.svg" width="150">
                <div style="margin-top: 8rem;">
                    <div class="header-content">
                        Reset Password
                    </div>
                    <div class="mt-2 font-13" style="color: #3F3C3C;">Enter your new password to reset your password</div>
                    <div class="mt-4 card border-0" id="userform">
                        <mat-form-field appearance="outline" class="w-100 top-left-border top-right-border">
                            <mat-label>New Password</mat-label>
                            <input matInput [type]="showNewPassword ? 'text' : 'password'" [(ngModel)]="newPassword">
                            <mat-icon matSuffix class="primary-eye" (click)="showNewPassword = !showNewPassword">{{showNewPassword ? 'visibility' : 'visibility_off'}}</mat-icon>
                        </mat-form-field>
                        <mat-form-field appearance="outline" class="w-100 bottom-left-border bottom-right-border">
                            <mat-label>Confirm Password</mat-label>
                            <input matInput [type]="showConfirmPassword ? 'text' : 'password'" [(ngModel)]="confirmPassword">
                            <mat-icon matSuffix class="primary-eye" (click)="showConfirmPassword = !showConfirmPassword">{{showConfirmPassword ? 'visibility' : 'visibility_off'}}</mat-icon>
                        </mat-form-field>
                    </div>
                    <button class="btn w-100 mt-5" style="background-color: var(--primary-btn-color);color: white;height: 55px;" [disabled]="!newPassword.trim() || !confirmPassword.trim()" (click)="resetPassword()"><span>Reset Password</span></button>
                    <div class="text-center primary-txt mt-4 cursor" (click)="serviceManager.goBack()" *ngIf="!isUser">Back</div>
                </div>
            </div>
            <div class="col"></div>
        </div>
    </div>
    <div class="col-6 p-0 responsive-reset-image">
        <img class="halfweb-image" src="../../assets/img/signup_bg2.jpg">
    </div>
</div>